
import { executeEntityValidators, ValidationWarnings } from "../../../shared/validation/entity-validation.util";
import { RangerSourceMap } from "../../ranger_source/model/ranger-source-map.model";
import { Ranger } from "./ranger.model";


// Ranger validation
export function validateRangerAgainstSource(ranger: Ranger): ValidationWarnings | null {
  if (ranger?.rangerSource == null) {
    return null;
  }
  
  const validationFunctions = [validateRangerExistsInSource, validateRangerDate,validateRangerName, 
                                validateRangerBusinessUnits, validateRangerCostCentres];
  return executeEntityValidators(ranger, validationFunctions);
}

export function validateRangerExistsInSource(ranger: Ranger): ValidationWarnings | null {
  const rangerSource = ranger.rangerSource;
  if (rangerSource.sourceExists || ranger.volunteerRanger) {
    return null;
  }
  return {
    rangerSourceNotExists: "Ranger does not exist in WMS, please create in WMS."
  };
}

  export function validateRangerDate(ranger: Ranger): ValidationWarnings | null {
  const rangerSource = ranger.rangerSource;
  if (!rangerSource.sourceExists) {
    return null;
  } else {
      if (!rangerSource.sourceValidByDate) {
        if (ranger.status == 'A') {
	    		return {
			    	rangerSourceDateInvalid: "The ranger record in WMS is inactive, please check their dates."
  			  };
        } 
      } else {
      if (ranger.status == 'C') {
        return {
            rangerSourceDateValidRangerClosed: "The ranger record in WMS is active, but this ranger is not active here"
        };
			}
    }
  }
}

export function validateRangerName(ranger: Ranger): ValidationWarnings | null {
  const rangerSource = ranger.rangerSource;
  if (!rangerSource.sourceExists) {
    return null;
  } else {
    if (rangerSource.sourceName?.toLowerCase() != ranger.name?.toLowerCase()) { 
      return {
        rangerSourceNameMismatch: "The ranger record in WMS has a different name: " + rangerSource.sourceName
      };
    }
  }
}

export function validateRangerEmail(rangerSource: RangerSourceMap): ValidationWarnings | null {
  if (!rangerSource.sourceExists) {
    return null;
  } else {
    if (!rangerSource.sourceValidRangerEmail) { 
      return {
        rangerSourceEmailInvalid: "The ranger in WMS has no email address and cannot be linked to an eAssets Ranger."
      };
    }
  }
}

export function validateRangerBusinessUnits(ranger: Ranger): ValidationWarnings | null {
  const rangerSource = ranger.rangerSource;
  const rangerBusinessUnitIds = ranger.rangerSource.businessUnitIds;
  if (!rangerSource.sourceExists) {
    return null;
  } else {
    if (!rangerBusinessUnitIds.includes(ranger.businessUnit?.buId)) { 
      return {
        rangerBusinessUnitMismatch: "This business unit does not match any currently assigned to WMS ranger which are in group [" + rangerBusinessUnitIds + "]"
      };
    }
  }
}

export function validateRangerCostCentres(ranger: Ranger): ValidationWarnings | null {
  const rangerSource = ranger.rangerSource;
  const rangerCostCentreIds = ranger.rangerSource.costCentreIds;
  if (!rangerSource.sourceExists) {
    return null;
  } else {
    if (!rangerCostCentreIds.includes(ranger.costCentre?.ccId)) { 
      return {
        rangerCostCentreMismatch: "This cost center does not match any currently assigned to WMS ranger which are in group [" + rangerCostCentreIds + "]"
      };
    }
  }
}